export default "__VITE_ASSET__DaKMX5qB__"